import {
  Row,
  Col,
  Typography,
  Button,
  Form,
  Divider,
  Space,
  Input,
  Checkbox,
  Image,
  Modal,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SessionLogout from "@assets/SVG/sessionLogout.svg";
import { Icon } from "@iconify/react";
import { Formik } from "formik";
import { useAuth } from "@hooks/useAuth";
import { OnBoarding } from "@components/index";
import * as yup from "yup";
import styles from "../Auth.module.scss";
import { SignInWithAzureAD } from "./SignInWithAzureAD";
import { strings } from "~/Utils/Strings";
import { useEffect, useState } from "react";
import logo from "@assets/SVG/logo.svg";

const { Title, Text } = Typography;

export const Login = () => {
  const { login, isLoading } = useAuth();
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (state && state.sessionExpired) {
      setOpen(true);
    }
  }, [state]);
  const handleModal = () => {
    setOpen(false);
    window.history.replaceState({}, document.title);
  };

  return (
    <OnBoarding>
      <Row className="login-form">
        <Col span={18} offset={3}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              justifyContent: "center",
              marginBottom: styles.whitespace2,
            }}
          >
            <Image
              src={logo}
              preview={false}
              style={{
                maxWidth: 120,
                cursor: "pointer",
              }}
            />
          </div>

          <Title
            level={2}
            style={{
              textAlign: "center",
              marginBottom: 20,
              color: "#0C233C",
            }}
            className="textLarge"
          >
            Login to your account
          </Title>

          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <Text className="textSmall" style={{ color: "#636363" }}>
              Enter to continue and explore with in to our grasp
            </Text>
          </div>
          <Col span={24}>
            <Formik
              initialValues={{ emailAddress: "", password: "" }}
              validationSchema={yup.object().shape({
                emailAddress: yup
                  .string()
                  .email("Please enter valid email address")
                  .required("Email address required"),
                password: yup
                  .string()
                  .matches(
                    new RegExp(
                      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
                    ),
                    "Please enter valid password"
                  )
                  .required("Password required")
                  .min(8),
              })}
              onSubmit={(values) => {
                login(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isValid,
                dirty,
              }) => {
                return (
                  <>
                    <Form layout="vertical" onFinish={handleSubmit}>
                      <div style={{ marginBottom: 20 }}>
                        <Form.Item>
                          <Input
                            name="emailAddress"
                            type={"email"}
                            size="large"
                            value={values.emailAddress}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={
                              errors.emailAddress && touched.emailAddress
                                ? styles.inputErrorFiled
                                : ""
                            }
                            placeholder="Email"
                            prefix={
                              <Icon icon="mdi:email-outline" color="#607D8B" />
                            }
                          />
                          {errors.emailAddress && touched.emailAddress && (
                            <Text type="danger">{errors.emailAddress}</Text>
                          )}
                        </Form.Item>
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <Form.Item>
                          <Input.Password
                            size="large"
                            onBlur={handleBlur}
                            iconRender={(visible) =>
                              visible ? (
                                <Icon
                                  icon="akar-icons:eye-open"
                                  style={{
                                    cursor: "pointer",
                                    color: styles.gray,
                                  }}
                                />
                              ) : (
                                <Icon
                                  icon="akar-icons:eye-closed"
                                  style={{
                                    cursor: "pointer",
                                    color: styles.gray,
                                  }}
                                />
                              )
                            }
                            name="password"
                            className={
                              errors.password && touched.password
                                ? styles.inputErrorFiled
                                : ""
                            }
                            value={values.password}
                            placeholder="Password"
                            onChange={handleChange}
                            prefix={
                              <Icon
                                icon="mdi:password-outline"
                                color="#607D8B"
                              />
                            }
                          />
                          {errors.password && touched.password && (
                            <Text type="danger">{errors.password}</Text>
                          )}
                        </Form.Item>
                      </div>
                      <Row
                        style={{ marginBottom: styles.whitespace2 }}
                        gutter={[0, 0]}
                        justify="space-between"
                      >
                        <Col>
                          <Checkbox>Remember me</Checkbox>
                        </Col>
                        <Col>
                          <Link
                            className={styles.loginFormForgot}
                            to="/auth/verify-email"
                          >
                            Forgot password ?
                          </Link>
                        </Col>
                      </Row>
                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className={styles.loginButton}
                          size="large"
                          block
                          loading={isLoading}
                          onClick={() => navigate("/dashboard")}
                        >
                          Login to continue
                        </Button>
                      </Form.Item>
                    </Form>
                    <Modal
                      open={open}
                      closable={false}
                      maskClosable={false}
                      footer={null}
                      centered
                      width={500}
                    >
                      <Row justify="center">
                        <Col>
                          <Image src={SessionLogout} preview={false} />
                        </Col>
                      </Row>
                      <Row justify="center" style={{ margin: 16 }}>
                        <Col style={{ textAlign: "center" }}>
                          <h3
                            style={{
                              fontWeight: "bold",
                              color: "red",
                              paddingBottom: 15,
                            }}
                          >
                            {strings.sessionExpired}
                          </h3>
                          <Text>{strings.sessionExpireMsg}</Text>
                        </Col>
                      </Row>
                      <Row justify="center" style={{ margin: 20 }}>
                        <Col>
                          <Button
                            key="submit"
                            type="primary"
                            onClick={() => handleModal()}
                          >
                            {strings.ok}
                          </Button>
                        </Col>
                      </Row>
                    </Modal>
                  </>
                );
              }}
            </Formik>
          </Col>
          <Row>
            <Col
              span={24}
              style={{ marginTop: styles.whitespace3, textAlign: "center" }}
            >
              <Space>
                <Typography.Text className={styles.loginDontText}>
                  Don't have an account?
                </Typography.Text>
                <Link
                  to="/auth/signup"
                  style={{ fontWeight: "bold" }}
                >
                  Sign Up
                </Link>
              </Space>
            </Col>
          </Row>
          <Button
            htmlType="submit"
            // className={styles.loginButton}
            size="large"
            block
            style={{ marginTop: 10 }}
            loading={isLoading}
          >
            <Space
              size={"middle"}
              style={{
                display: "flex",
                verticalAlign: "middle",
                alignItems: "center",
              }}
            >
              <Icon
                icon={"logos:google-icon"}
                style={{ verticalAlign: "middle" }}
              ></Icon>
              <Typography.Text>Google</Typography.Text>
            </Space>
          </Button>
        </Col>
      </Row>
    </OnBoarding>
  );
};
